import {
  find, isEmpty, sortBy,
} from 'lodash';
import moment from 'moment';
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthState } from '../../preorder/plugins/Auth';
import { checkCouponsDiscount } from '../api/menu';
import CouponSelector from '../components/CouponSelector';

export default ({
  isOpen,
  onClose,
  onSelect,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [couponsDiscount, setCouponsDiscount] = useState({});
  const { token } = useAuthState();
  const { state: { items } } = useLocation();
  const { vouchers, discount: discountDict } = couponsDiscount || {};

  const loadData = useCallback(
    async () => {
      setIsLoading(true);

      try {
        const couponsDiscountResult = await checkCouponsDiscount({ token, items });
        const { data } = couponsDiscountResult || {};

        setCouponsDiscount(data || {});
      } catch (e) {
      // ignore error
      }

      setIsLoading(false);
    }, [items, token]
  );

  useEffect(() => {
    if (
      isEmpty(items)
      || !isOpen
    ) return;

    (async () => {
      await loadData();
    })();
  }, [token, items, isOpen, loadData]);

  const data = useMemo(() => {
    if (isEmpty(vouchers)) return [];

    const list = vouchers.map((voucher) => {
      const { expiredTime, gotTime, id } = voucher || {};
      const { [id]: discount } = discountDict || {};

      return {
        ...voucher,
        ...(expiredTime && {
          expirationTimeString: moment(expiredTime).utcOffset(8).format('YYYY/MM/DD HH:mm'),
        }),
        ...(gotTime && {
          gotTimeString: moment(gotTime).utcOffset(8).format('YYYY/MM/DD HH:mm'),
        }),
        ...discount,
      };
    });
    return sortBy(list, 'discount').reverse();
  }, [vouchers, discountDict]);

  const onCouponVoucherClick = (id) => {
    const couponVoucher = find(data, ['id', id]);

    onSelect(couponVoucher);
  };

  return (
    <CouponSelector
      afterSendButtonClick={loadData}
      isLoading={isLoading}
      isOpen={isOpen || false}
      onClose={onClose}
      onCouponVoucherClick={onCouponVoucherClick}
      vouchers={data}
    />
  );
};
